import { render, staticRenderFns } from "./remittance.vue?vue&type=template&id=bc3f5146&scoped=true&"
import script from "./remittance.vue?vue&type=script&lang=js&"
export * from "./remittance.vue?vue&type=script&lang=js&"
import style0 from "./remittance.vue?vue&type=style&index=0&id=bc3f5146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3f5146",
  null
  
)

export default component.exports